import {
  DurationIcon,
  HbTooltip,
  IconButton,
  ReclassifyIcon,
  StatusIcon,
} from '@cdl/heartbeat-react';
import { EPlotType } from '../../types/annotation-task-detail.type';

type Props = {
  type: EPlotType;
  tooltip: string;
  toggleChart: (chart: EPlotType) => void;
  selectedChart: EPlotType;
};

const buttonIcon = (type: EPlotType) => {
  switch (type) {
    case EPlotType.DailyUserCompletion:
      return <StatusIcon />;
    case EPlotType.DailyTotalCompletion:
      return <ReclassifyIcon />;
    case EPlotType.DailyUserWorktime:
      return <DurationIcon />;
  }
};
export const DailyCompletionButton: React.FC<Props> = ({
  type,
  tooltip,
  toggleChart,
  selectedChart,
}) => {
  return (
    <HbTooltip label={tooltip} placement='top' hasArrow>
      <IconButton
        variant='tertiary'
        size='sm'
        _active={{
          color: 'primary.500',
        }}
        onClick={() => toggleChart(type)}
        isActive={selectedChart === type}
        aria-label={type + 'select'}
        icon={buttonIcon(type)}
        mr='s'
      />
    </HbTooltip>
  );
};
